import { Reveal, Eyebrow } from "./Reveal";

const CLIENTS = [
  {
    name: "Private Families & Family Offices",
    desc: "We support families with direct investment strategies, significant acquisitions and broader private capital decisions.",
  },
  {
    name: "Asset Managers & Investment Firms",
    desc: "We work with investment managers and private capital firms seeking strategic opportunities, investment partnerships and transaction support.",
  },
  {
    name: "Institutional Investors",
    desc: "We support sophisticated investors evaluating acquisitions, complex assets and private market transactions.",
  },
  {
    name: "Business & Asset Owners",
    desc: "We advise owners considering disposals, strategic partnerships, investment and changes in ownership.",
  },
];

export const OurClients = () => (
  <section data-testid="clients-section" className="relative py-28 lg:py-44 bg-[#FFFFFF] border-y border-[#E3E0D8]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="max-w-3xl">
        <Reveal>
          <Eyebrow>Institutional Relationships</Eyebrow>
          <h2 className="mt-8 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#1F1E1B] leading-[1.08]">
            Built around the <span className="italic">interests of capital.</span>
          </h2>
          <p className="mt-7 text-base sm:text-lg font-light text-[#6E6A61] leading-relaxed">
            We seek to build long-term relationships with family offices, asset managers, private equity
            firms and institutional investors, supporting their strategic objectives through independent
            thinking and targeted transaction expertise.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 lg:mt-24 grid md:grid-cols-2 gap-x-12 lg:gap-x-20">
        {CLIENTS.map((c, i) => (
          <Reveal key={c.name} delay={i * 0.08}>
            <div data-testid={`client-group-${i}`} className="group border-t border-[#E3E0D8] py-10 lg:py-12">
              <span className="font-sans text-[11px] tracking-[0.24em] text-[#6E6A61] group-hover:text-[#1F1E1B] transition-colors duration-500">
                0{i + 1}
              </span>
              <h3 className="mt-5 font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#1F1E1B]">
                {c.name}
              </h3>
              <p className="mt-4 max-w-md text-sm sm:text-base leading-relaxed text-[#6E6A61]">{c.desc}</p>
              <span className="mt-8 block h-px w-full bg-[#E3E0D8] relative overflow-hidden">
                <span className="absolute inset-0 bg-[#1F1E1B]/60 -translate-x-full group-hover:translate-x-0 transition-transform duration-700 ease-[cubic-bezier(0.16,1,0.3,1)]" />
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
